<template>
  <div id="tax-title">
    <v-avatar v-if="boxNumber" :color="color" size="30" class="mr-3">
      <span class="white--text" :class="{ 'small-text': boxNumber > 1000 }">{{ boxNumber }}</span>
    </v-avatar>
    <h1>
      {{ title }}
    </h1>
    <span v-if="infoIconText" class="ml-2">
      <InfoIcon :size="18" :text="infoIconText" />
    </span>
  </div>
</template>

<script>
import InfoIcon from '@/views/components/common/InfoIcon.vue'

export default {
  components: { InfoIcon },
  props: {
    title: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    boxNumber: {
      type: Number,
      default: null,
    },
    infoIconText: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss">
#tax-title {
  display: flex;
  align-items: center;
  margin-top: 20px;
  h1 {
    font-size: 16px;
    font-weight: 300;
  }

  .small-text {
    font-size: 12px;
  }
}
</style>
